// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"18":"7260affd","118":"7260affd","229":"fe08088f","652":"7260affd","903":"7260affd"}[chunkId] + ".chunk.css";
};